import * as _ from "lodash";
import * as VerifiedAddress from "../../Models/Customer/VerifiedAddress";
import IVerifiedAddress = VerifiedAddress.IVerifiedAddress;

export interface IAddressVerificationModalScope extends ng.IScope {
    addressVerificationModalCtrl: AddressVerificationModalCtrl;
}

export class AddressVerificationModalCtrl {
    verifiedAddress: IVerifiedAddress;
    typedAddress: IVerifiedAddress;
    pickedAddress: IVerifiedAddress;
    selectedAddressType: string;

    static $inject = [
        "$scope",
        "$modalInstance",
        "passedInVerifiedAddress",
        "passedInTypedAddress"
    ];

    constructor($scope: IAddressVerificationModalScope,
        public $modalInstance: angular.ui.bootstrap.IModalServiceInstance,
        public passedInVerifiedAddress: IVerifiedAddress,
        public passedInTypedAddress: IVerifiedAddress) {

        $scope.addressVerificationModalCtrl = this;
        this.verifiedAddress = passedInVerifiedAddress;
        this.typedAddress = passedInTypedAddress;

        if (passedInVerifiedAddress.zip4) {
            this.selectedAddressType = "verifiedAddress";
        } else {
            this.selectedAddressType = "typedAddress";
        }
    }

    submit = () => {
        this.determineAddressToUseFromUserInput();

        this.$modalInstance.close(this.pickedAddress);
    };

    close = () => {
        this.$modalInstance.dismiss();
    };

    private determineAddressToUseFromUserInput = (): void => {
        if (this.selectedAddressType === "typedAddress") {
            this.typedAddress.latitude = this.verifiedAddress.latitude;
            this.typedAddress.longitude = this.verifiedAddress.longitude;
            this.typedAddress.zip4 = this.verifiedAddress.zip4;
            this.typedAddress.countyName = this.verifiedAddress.countyName;
            this.pickedAddress = this.typedAddress;
        } else {
            this.pickedAddress = this.verifiedAddress;
        }
    };
}